<div class="wrapper">
  <a class="col-2" [hidden]="!profile?.ProfileId" (click)="navigateToProfilePortal()">
    {{ 'profiles.edit.web-portal-credentials.view-profiles-portal' | translate | titlecase }}
  </a>
  <div class="col-2 checkbox-row" *ngIf="changingCredentials">
    <input [checked]="isUsingSystemCredentials" (change)="onUseSystemCredentialsChange()" type="checkbox" />
    <span>{{ 'profiles.edit.web-portal-credentials.use-system-default' | translate | titlecase }}</span>
  </div>
  <span class="col-1">{{ 'profiles.edit.web-portal-credentials.username' | translate | titlecase }}:</span>
  <input [(ngModel)]="portalUsername" [disabled]="!changingCredentials" class="col-2" type="text" wlTrimInput />
  <div class="col-3" style="grid-row: 2 / 3;">
    <p-checkbox inputId="disablePortalLogin" [binary]="true" [(ngModel)]="profile.DisablePortalLogin"></p-checkbox>
    <label for="disablePortalLogin">{{
      'profiles.edit.web-portal-credentials.disable-portal-access' | translate | titlecase
      }}</label>
  </div>
  <span class="col-1">{{ 'profiles.edit.web-portal-credentials.password' | translate | titlecase }}:</span>
  <input [(ngModel)]="passwordValue" [disabled]="!changingCredentials" [type]="passwordFieldType" class="col-2"
    autocomplete="off" />

  <div class="btn btn-primary col-2" (click)="onChangeCredentialsClick()">{{ changeButtonText }}</div>
  <a class="col-2" (click)="onSendResetEmailClick()">{{
    'profiles.edit.web-portal-credentials.send-password-reset' | translate | titlecase
    }}</a>
  <div class="col-2">
    <p-checkbox inputId="inactive" [binary]="true" [(ngModel)]="profile.Inactive"></p-checkbox>
    <label for="inactive">{{ 'profiles.edit.web-portal-credentials.inactive' | translate | ucfirst }}</label>
  </div>
</div>
